import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { notificationsAPI } from '../services/api';
import { paths } from '../routes/paths';
import '../styles/notifications.css';

const POLL_MS = 60 * 1000;

// The bell in the site header: a link to the notifications page with the unread count. It asks the server
// for the count when the page changes and once a minute while the tab is open.
export default function NotificationBell() {
  const [unread, setUnread] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    let alive = true;
    const load = () => {
      if (document.hidden) return;
      notificationsAPI.list({ limit: 1 }).then((r) => alive && setUnread(r.unreadCount)).catch(() => {});
    };
    load();
    const timer = setInterval(load, POLL_MS);
    return () => { alive = false; clearInterval(timer); };
  }, [pathname]);

  return (
    <Link to={paths.notifications} className="bell" aria-label={unread ? `Notifications, ${unread} unread` : 'Notifications'}>
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 9a6 6 0 1 1 12 0c0 6 2 7.5 2 7.5H4S6 15 6 9Z" />
        <path d="M10 20a2 2 0 0 0 4 0" />
      </svg>
      {unread > 0 && <span className="bell-count">{unread > 9 ? '9+' : unread}</span>}
    </Link>
  );
}
